{
  "${{ productionAmount }} avg per appointment": "${{ productionAmount }} avg per appointment",
  "AI Conversations Over Time": "AI Conversations Over Time",
  "AI Driven Appointments": "AI Driven Appointments",
  "AI Handled": "AI Handled",
  "AI Receptionist": "AI Receptionist",
  "AI Receptionist Demo": "AI Receptionist Demo",
  "AI Receptionist Outcome": "AI Receptionist Outcome",
  "AI Receptionist Outcomes": "AI Receptionist Outcomes",
  "AI-Initiated Staff Transfer Calls": "AI-Initiated Staff Transfer Calls",
  "AI-Initiated Staff Transfer Conversation": "AI-Initiated Staff Transfer Conversation",
  "Added to Schedule": "Added to Schedule",
  "After-Hour Conversations": "After-Hour Conversations",
  "After-Hours Performance": "After-Hours Performance",
  "All Hours": "All Hours",
  "All incomplete tasks": "All incomplete tasks",
  "Apply Filters": "Apply Filters",
  "Appointment Request Created": "Appointment Request Created",
  "Appointment Rescheduled": "Appointment Rescheduled",
  "Appointments Booked": "Appointments Booked",
  "Appointments Scheduled": "Appointments Scheduled",
  "Appointments Scheduled by AI": "Appointments Scheduled by AI",
  "Appointments scheduled, rescheduled and appointment requests created by AI": "Appointments scheduled, rescheduled and appointment requests created by AI",
  "Appointments successfully scheduled or rescheduled by the AI, capturing both patient growth and retention": "Appointments successfully scheduled or rescheduled by the AI, capturing both patient growth and retention",
  "Appointments successfully scheduled/rescheduled by the AI Receptionist": "Appointments successfully scheduled/rescheduled by the AI Receptionist",
  "Ask Sam anything...": "Ask Sam anything...",
  "Call Handling": "Call Handling",
  "Calls answered by the AI and were subsequently transferred to a staff member for completion": "Calls answered by the AI and were subsequently transferred to a staff member for completion",
  "Calls categorized under scheduling and general tasks have pending follow-ups that may need attention.": "Calls categorized under scheduling and general tasks have pending follow-ups that may need attention.",
  "Cancel": "Cancel",
  "Channel": "Channel",
  "Check which calls could be converted into appointments.": "Check which calls could be converted into appointments.",
  "Clear All Filters": "Clear All Filters",
  "Clear previous conversation": "Clear previous conversation",
  "Click the call button to start a simulated call with the AI Receptionist": "Click the call button to start a simulated call with the AI Receptionist",
  "Closed Hours": "Closed Hours",
  "Confirmation Text Sent to phone number": "Confirmation Text Sent to phone number",
  "Confirmation Text Sent to {{phoneNumber}}": "Confirmation Text Sent to {{phoneNumber}}",
  "Contact Name": "Contact Name",
  "Contact Number": "Contact Number",
  "Contact Type": "Contact Type",
  "Conversation Intent": "Conversation Intent",
  "Conversation Start Time": "Conversation Start Time",
  "Conversations handled by the AI Receptionist that were later transferred to a staff member for completion": "Conversations handled by the AI Receptionist that were later transferred to a staff member for completion",
  "Conversations where the customer actively interacts with the AI": "Conversations where the customer actively interacts with the AI",
  "Conversations with Contact Response": "Conversations with Contact Response",
  "Engaged Calls": "Engaged Calls",
  "Engagement Rate": "Engagement Rate",
  "Estimated Production Value": "Estimated Production Value",
  "Estimated Production impact (in $) from new appointments and rescheduled appointments driven by AI": "Estimated Production impact (in $) from new appointments and rescheduled appointments driven by AI",
  "Existing {{patientCapitalizedToken}}": "Existing {{patientCapitalizedToken}}",
  "Filter AI Receptionist": "Filter AI Receptionist",
  "Follow-up Tasks": "Follow-up Tasks",
  "Follow-up opportunities identified": "Follow-up opportunities identified",
  "Hand-off Reasons": "Hand-off Reasons",
  "Handled By": "Handled By",
  "Incomplete tasks with scheduling related intent": "Incomplete tasks with scheduling related intent",
  "Intents": "Intents",
  "Loading demo data...": "Loading demo data...",
  "Location": "Location",
  "Location Phone Number": "Location Phone Number",
  "Locations with AI Receptionist access": "Locations with AI Receptionist access",
  "Message": "Message",
  "Messages where the AI identified a scheduling opportunity, but no appointment was booked and staff follow-up may be needed.": "Messages where the AI identified a scheduling opportunity, but no appointment was booked and staff follow-up may be needed.",
  "Number of daily conversations where AI sent at least one text message": "Number of daily conversations where AI sent at least one text message",
  "Office Number": "Office Number",
  "Open Hours": "Open Hours",
  "Outcomes": "Outcomes",
  "Patient conversations where the AI identified a potential appointment opportunity. These may be scheduled automatically or require staff follow-up.": "Patient conversations where the AI identified a potential appointment opportunity. These may be scheduled automatically or require staff follow-up.",
  "Patients Intent": "Patients Intent",
  "Pending Non-Scheduling Tasks:": "Pending Non-Scheduling Tasks:",
  "Pending Scheduling Tasks ": "Pending Scheduling Tasks ",
  "Pending Scheduling Tasks:": "Pending Scheduling Tasks:",
  "Phone Hours": "Phone Hours",
  "Phone Number": "Phone Number",
  "Phone Number Name": "Phone Number Name",
  "Please enter the phone number you would like the AI Receptionist to send appointment information to:": "Please enter the phone number you would like the AI Receptionist to send appointment information to:",
  "Production Value": "Production Value",
  "Production impact (in $) from new appointments and rescheduled appointments driven by AI": "Production impact (in $) from new appointments and rescheduled appointments driven by AI",
  "Removed from Schedule": "Removed from Schedule",
  "Result": "Result",
  "Review": "Review",
  "Review Calls": "Review Calls",
  "Review Follow-Up Tasks": "Review Follow-Up Tasks",
  "Review Messages": "Review Messages",
  "Review Opportunities": "Review Opportunities",
  "Review these calls to ensure no patient requests are missed.": "Review these calls to ensure no patient requests are missed.",
  "Review these messages to ensure patients receive timely follow-up.": "Review these messages to ensure patients receive timely follow-up.",
  "Scheduling": "Scheduling",
  "Scheduling Opportunities": "Scheduling Opportunities",
  "Scheduling Opportunity": "Scheduling Opportunity",
  "Scheduling opportunities that resulted in an appointment being successfully booked after AI or staff interaction.": "Scheduling opportunities that resulted in an appointment being successfully booked after AI or staff interaction.",
  "Select AI Outcomes": "Select AI Outcomes",
  "Select Intents": "Select Intents",
  "Select Patients Intent": "Select Patients Intent",
  "Select Task Status": "Select Task Status",
  "Select Task Type": "Select Task Type",
  "Showing results for {{filtersInfo}}.": "Showing results for {{filtersInfo}}.",
  "Shows the impact of AI Receptionist after business hours, including patient engagement, appointments booked, and revenue captured.": "Shows the impact of AI Receptionist after business hours, including patient engagement, appointments booked, and revenue captured.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Staff Transfers": "Staff Transfers",
  "Start Demo": "Start Demo",
  "Start New Conversation": "Start New Conversation",
  "Task Status": "Task Status",
  "Task Type": "Task Type",
  "Tasks": "Tasks",
  "Tasks created by AI Receptionist": "Tasks created by AI Receptionist",
  "Tasks created by AI Receptionist that require staff action, including follow-ups, scheduling assistance, and unresolved patient requests.": "Tasks created by AI Receptionist that require staff action, including follow-ups, scheduling assistance, and unresolved patient requests.",
  "The AI Receptionist will send appointment confirmations to {{phoneNumber}}": "The AI Receptionist will send appointment confirmations to {{phoneNumber}}",
  "This is a simulated phone call with the AI Receptionist. No real phone calls are being placed by your office.": "This is a simulated phone call with the AI Receptionist. No real phone calls are being placed by your office.",
  "Top AI Conversation Intent": "Top AI Conversation Intent",
  "Top AI Conversation Outcomes": "Top AI Conversation Outcomes",
  "Top AI Handed Off Reasons": "Top AI Handed Off Reasons",
  "Total": "Total",
  "Total AI Answered Calls": "Total AI Answered Calls",
  "Total AI Calls": "Total AI Calls",
  "Total AI Conversations": "Total AI Conversations",
  "Total Appointments": "Total Appointments",
  "Total Pending Tasks ": "Total Pending Tasks ",
  "Total Tasks Created": "Total Tasks Created",
  "Total Tasks Created:": "Total Tasks Created:",
  "Total conversations where AI sent message gets at least one reply": "Total conversations where AI sent message gets at least one reply",
  "Total follow-up tasks created by the AI receptionist": "Total follow-up tasks created by the AI receptionist",
  "Total number of calls answered by AI": "Total number of calls answered by AI",
  "Total number of conversations where AI sent at least one text message (including Missed Call Text)": "Total number of conversations where AI sent at least one text message (including Missed Call Text)",
  "Unknown {{patientCapitalizedToken}}": "Unknown {{patientCapitalizedToken}}",
  "View": "View",
  "View Calendar": "View Calendar",
  "View Tasks": "View Tasks",
  "Voice": "Voice",
  "You'll hear how it would respond to patients using the information you've saved in the AI Receptionist's settings.": "You'll hear how it would respond to patients using the information you've saved in the AI Receptionist's settings.",
  "Your settings have been updated. Start a new call to test the AI Receptionist's latest knowledge.": "Your settings have been updated. Start a new call to test the AI Receptionist's latest knowledge.",
  "air": {
    "AI detected scheduling related intent in the conversation": "AI detected scheduling related intent in the conversation",
    "An appointment was scheduled during the AI conversation.": "An appointment was scheduled during the AI conversation.",
    "An appointment was scheduled within 30 days after the AI conversation.": "An appointment was scheduled within 30 days after the AI conversation.",
    "Contact had an intent related to scheduling or rescheduling an appointment.": "Contact had an intent related to scheduling or rescheduling an appointment.",
    "Scheduling Opportunities": "Scheduling Opportunities",
    "Total tasks created by AI Receptionist": "Total tasks created by AI Receptionist"
  },
  "appointment_one": "appointment",
  "appointment_other": "appointments",
  "conversation_one": "conversation",
  "conversation_other": "conversations",
  "engagedCallsAndAppointmentsBanner": "engagedCallsAndAppointmentsBanner",
  "{{count}} Location, {{timePeriod}}_one": "{{count}} Location, {{timePeriod}}",
  "{{count}} Location, {{timePeriod}}_other": "{{count}} Location, {{timePeriod}}",
  "{{count}} locations, {{timePeriod}}_one": "{{count}} locations, {{timePeriod}}",
  "{{count}} locations, {{timePeriod}}_other": "{{count}} locations, {{timePeriod}}",
  "{{count}} transfered messages require staff attention._one": "{{count}} transfered message require staff attention.",
  "{{count}} transfered messages require staff attention._other": "{{count}} transfered messages require staff attention.",
  "{{seriesKey}}": "{{seriesKey}}",
  "{{unanswered_count}} patient calls were transferred by the AI Receptionist but not answered by staff.": "{{unanswered_count}} patient calls were transferred by the AI Receptionist but not answered by staff.",
  "{{unscheduled_opportunities}} Unscheduled Opportunities": "{{unscheduled_opportunities}} Unscheduled Opportunities"
}
